
requirejs.config({
    baseUrl: '/js'
});

require(['jquery', 'underscore', 'marionette', 'app'], function ($, _, Marionette, Application) {
    
    $('.navbar-brand').on('click', function(e) {
        if (!window.currentRoute) {
            e.preventDefault();
            Application.navigate('pages/home', { trigger: true });
        }
    });
    
    $('.navbar-brand').clone().addClass('fade').appendTo('body');
    
    $.fn.randomize = function(selector) {
        (selector ? this.find(selector) : this).parent().each(function(){
            $(this).children(selector).sort(function(){
                return Math.random() - 0.5;
            }).detach().appendTo(this);
        });
        return this;
    };
    
    Application.start({ pushState: false });
});
define("main", function(){});
